import { render, staticRenderFns } from "./ProjectScopeEditorModal.vue?vue&type=template&id=151cf9f2"
import script from "./ProjectScopeEditorModal.vue?vue&type=script&lang=js"
export * from "./ProjectScopeEditorModal.vue?vue&type=script&lang=js"
import style0 from "./ProjectScopeEditorModal.vue?vue&type=style&index=0&id=151cf9f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports